import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DynamicGrid } from '../../models/dynamic.model';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { NavigationService } from '../../services/navigation.service';
import { BaseListComponent } from '../../models/base/base-list.component';
import { ListService } from '../../services/list.service';
import { RowToolEvent, RowTools } from '../../models/row-tools.model';
import { DatePipe } from '@angular/common';
import { ReportingService } from '../../services/reporting.service';
import { SharedService } from '../../services/shared.service';
import { AccountService } from '../../services/account.service';
import { environment } from '../../environments/environment';
import { Subject, takeUntil, debounceTime } from 'rxjs';

@Component({
  selector: 'app-orders',
  templateUrl: 'order-list.component.html',
  providers: [ListService, ReportingService],
})
export class OrderListComponent extends BaseListComponent implements OnInit, OnDestroy {
  showUserModal: boolean = false;
  showLocationModal: boolean = false;
  startDate: Date = null;
  reportData = []
  totalWeek: any = {
    totalMonday: 0,
    totalTuesday: 0,
    totalWednesday: 0,
    totalThursday: 0,
    totalFriday: 0,
    totalSaturday: 0,
    total: 0
  };
  isReportSearch = false;
  startDateReport = null;
  endDateReport = null;
  now = new Date();
  minDate = new Date('11/13/2022');
  tempChildKey = '';
  userId: any;
  truckOverhaulOrderNumber:number = environment.truckOverhaulOrderNumber;
  proxy: any[]=[];
  private destroy$ = new Subject<void>();
  showBulkEditModal: boolean = false;
  @ViewChild("orderDialog", { static: false }) dialogRef: ElementRef;
  isShowCheckBox: boolean = false;
  selectedRows = []
  public multiSortMeta: any = [];
  prevLazyLoadEvent: LazyLoadEvent | null = null;
  isDataLoaded: boolean = false;
  hasUnlockPermission: boolean = false;
  showUnlockConfirm: boolean = false;
  unlockOrderItem: any = null;

  constructor(
    protected messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute,
    private listService: ListService,
    private sharedService: SharedService,
    private reportingService: ReportingService,
    private datePipe: DatePipe,
    private accountService: AccountService,
    private navigationService: NavigationService) {
    super();
  }

  ngOnInit() {
    this.setStartDateToMostRecentMonday();
    
    this.userId = +localStorage.getItem('userId');
    this.subs['editSub'] = this.navigationService.edit$.subscribe((res) => {
      this.showModal = false;
      if (res) {
        const item = this.sharedService.getData("items");
        const event = {
          item,
          key: "edit",
          tool: {
            key: "edit",
            type: "link",
            label: "Edit"
          }
        }
        this.clickRowTools(event)
        this.sharedService.removeData("items");
      }
    });

    this.subs['checkBoxSub'] = this.sharedService.bulkEditcurrentStatus.subscribe((value) => {
      this.isShowCheckBox = value;
      if (!this.isShowCheckBox) {
        this.selectedRows = [];
      }
    })

    this.subs['proxyFor'] = this.navigationService.proxy$
      .pipe(
        debounceTime(300),
        takeUntil(this.destroy$)
      )
      .subscribe((v: any[]) => {
        this.proxy = v || [];
        this.first = 0;
        // For Orders in Process, only load if reps are selected
        if (this.params.status === 8) {
          this.isDataLoaded = this.proxy.length > 0;
          if (this.isDataLoaded) {
            this.load();
          } else {
            this.model.rows = [];
            this.rowCount = 0;
            this.navigationService.setTitleAndSub({
              title: this.title,
              subtitle: '',
            });
          }
        } else {
          this.load();
        }
      });

    this.class = 'order';
    this.title = 'Orders';

    this.rowTools = new RowTools();
    if (this.sharedService.getPermissions("orders_edit")) {
      this.rowTools.addLink('edit', 'Edit');
    }
    this.rowTools.addLink('view', 'View');
    this.hasUnlockPermission = this.sharedService.getPermissions('orders_unlock');

    let userRole = localStorage.getItem('userRole');
    if (userRole == 'Carrier') {
      this.router.navigateByUrl('/carrier-dashboard');
    }



    //#region grid model

    this.model = new DynamicGrid<any>();
    this.model.columns = [
      { filterable: false, key: 'id', sortable: false, lookupKey: null, name: 'Id', order: 0, visible: false, valueColumn: null, width: null, type: 'text' },
      { filterable: false, key: 'number', sortable: true, lookupKey: null, name: 'No.', order: 0, visible: true, valueColumn: null, width: '70', type: 'text' },
      { filterable: false, key: 'businessName', sortable: true, lookupKey: null, name: 'Business Name', order: 0, visible: true, valueColumn: null, width: '220', type: 'text' },
      { filterable: false, key: 'statusName', sortable: true, lookupKey: null, name: 'Status', order: 0, visible: true, valueColumn: null, width: '160', type: 'text' },
      { filterable: false, key: 'assignedToName', sortable: true, lookupKey: null, name: 'Assigned To', order: 0, visible: true, valueColumn: null, width: '160', type: 'text' },
      { filterable: false, key: 'pickupCityState', sortable: true, lookupKey: null, name: 'Pickup City', order: 0, visible: true, valueColumn: null, width: '160', type: 'text' },
      { filterable: false, key: 'deliveryCityState', sortable: true, lookupKey: null, name: 'Delivery City', order: 0, visible: true, valueColumn: null, width: '160', type: 'text' },
      { filterable: false, key: 'assignedCarrierName', sortable: true, lookupKey: null, name: 'Carrier Assigned', order: 0, visible: true, valueColumn: null, width: '160', type: 'text' },
      { filterable: false, key: 'numVehicles', sortable: true, lookupKey: null, name: 'Vehicles', order: 0, visible: true, valueColumn: null, width: '160', type: 'number' },
      { filterable: false, key: 'priceToCarrier', sortable: true, lookupKey: null, name: 'Price To Carrier', order: 0, visible: true, valueColumn: null, width: '160', type: 'currency' },

      { filterable: false, key: 'updatedByName', sortable: true, lookupKey: null, name: 'Updated By', order: 0, visible: true, valueColumn: null, width: '160', type: 'text' },
      { filterable: false, key: 'updatedOn', sortable: true, lookupKey: null, name: 'Updated On', order: 0, visible: true, valueColumn: null, width: '160', type: 'datetime' },
    ];

    //#endregion

    //#region set nav state

    this.navigationService.setTitle(this.title);
    this.navigationService.showTopNav(true);
    this.navigationService.setLeftNav('menu', 'orders');
    this.navigationService.showButton(true);
    this.navigationService.showFilter(true, true);
    this.navigationService.clearButton();

    //#endregion

    //#region subscriptions

    this.navigationService.setLeftNav(null, 'orders');
    this.clickChild(null, false, false);


    this.subs['leftNav'] = this.navigationService.leftNav$.subscribe(v => {
      this.multiSortMeta = [];
      this.prevLazyLoadEvent=null;
      if (v.child != this.childKey && v.child != '' || v.area=='orders') {
        this.clickChild(v.child, false, true);
      }
      if (v.area !== 'orders') {
        this.childKey = '';
      } else {
        this.childKey = v.child;
      }
      this.tempChildKey = this.childKey;
    });

    this.subs['clickButton'] = this.navigationService.clickNewOrder$.subscribe(s => {
      this.add();
    });

    this.subs['clickUserButton'] = this.navigationService.clickNewUser$.subscribe(s => {
      this.addUser();
    });

    this.subs['clickLocationButton'] = this.navigationService.clickNewLocation$.subscribe(s => {
      this.addLocation();
    });

    this.subs['clickBeginBulkEditButton'] = this.navigationService.clickBeginBulkEdit$.subscribe(s => {
      if (s) {
        this.showBulkEditModal = true;
      }
    });

    this.subs['filter'] = this.navigationService.filter$.subscribe(s => {
      if (this.query != s) {
        this.first = 0;
      }
      this.query = s;
      this.prevLazyLoadEvent.first = 0;
      if (this.childKey !== 'weekly_reporting') {
        this.load();
      }
    });

    this.route.queryParams.subscribe(p => {
      if (p['preview'] != null && p['preview'] !== '') {
        this.view(p['preview']);
      }
      if (p['show'] != null && p['show'] !== '') {
        this.edit({ id: p['show'] });
      }
    });

    //#endregion

  }

  ngOnDestroy() {
    this.safeUnsub('clickButton');
    this.safeUnsub('clickUserButton');
    this.safeUnsub('clickLocationButton');
    this.safeUnsub('filter');
    this.safeUnsub('leftNav');
    this.safeUnsub('editSub');
    this.safeUnsub("checkBoxSub");
    this.safeUnsub('clickBeginBulkEditButton');
    this.safeUnsub('orderList')
    this.destroy$.next();
    this.destroy$.complete();
  }

  load() {
    if (this.isLoading)
      return;

    // For Orders in Process (status 8), don't load if no assigned reps are selected
    if (this.params.status === 8 && this.proxy.length === 0) {
      this.isDataLoaded = false;
      this.model.rows = [];
      this.rowCount = 0;
      this.navigationService.setTitleAndSub({
        title: this.title,
        subtitle: '',
      });
      return;
    }

    this.isLoading = true;
    this.model.rows = [];
    if (this.params && Object.keys(this.params).length === 0) {
      this.params = { status: 8 };
    }
    this.rowCount = this.first == 0 ? 0 : this.rowCount;
    if (this.prevLazyLoadEvent) {
      this.prevLazyLoadEvent.first = this.first;
    }
    // switch (this.sortField) {
    //   case 'customerExpectedPickupDates':
    //     this.sortField = 'FirstcustomerExpectedPickup'
    //     break;
    //   case 'customerExpectedDeliveryDates':
    //     this.sortField = 'FirstcustomerExpectedDelivery'
    //     break;
    //   case 'carrierScheduledPickupDates':
    //     this.sortField = 'Firstcarrierscheduledpickup'
    //     break;
    //   case 'carrierScheduledDeliveryDates':
    //     this.sortField = 'Firstcarrierscheduleddelivery'
    //     break;
    //   case 'pickupNewETADates':
    //     this.sortField = 'FirstpickupNewETADate'
    //     break;
    //   case 'deliveryNewETADates':
    //     this.sortField = 'FirstdeliveryNewETADate'
    //     break;
    //   default:
    //     break;
    // }
    const fieldNameObj = {
      'customerExpectedPickupDates': 'FirstcustomerExpectedPickup',
      'customerExpectedDeliveryDates': 'FirstcustomerExpectedDelivery',
      'carrierScheduledPickupDates': 'Firstcarrierscheduledpickup',
      'carrierScheduledDeliveryDates': 'Firstcarrierscheduleddelivery',
      'pickupNewETADates': 'FirstpickupNewETADate',
      'deliveryNewETADates': 'FirstdeliveryNewETADate',
      'statusName': 'status',
    }
    const updatedMultiSortMeta = this.multiSortMeta.map((e) => {
      return { ...e, field: fieldNameObj[e.field] ? fieldNameObj[e.field] : e.field };
    })
    const proxyParam = this.proxy.length > 0 ? this.proxy.join() : null;
    if (this.params.proxy !== proxyParam) {
      this.params.proxy = proxyParam;
    }
    
    this['orderList']=this.listService
      .orders(
        this.params,
        this.query,
        this.first,
        this.rows,
        this.sortField,
        this.sortOrder,
        JSON.stringify(updatedMultiSortMeta)
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        let updatedMetaData = res.body.metadata.map((data) => {
          if (
            data.key === "customerExpectedPickupDates" ||
            data.key === "customerExpectedDeliveryDates" ||
            data.key === "carrierScheduledPickupDates" ||
            data.key === "carrierScheduledDeliveryDates" ||
            data.key === "pickupNewETADates" ||
            data.key === "deliveryNewETADates" ||
            data.key === "carrierTransportResultsList" ||
            data.key === "fscTransportResultsList" ||
            data.key === "driverName" ||
            data.key === "pickupDeliveryConfirmNotes"
          ) {
            data.type = "textarea";
          }
          if (
            data.key === "callback1date_only" ||
            data.key === "callback2date_only"
          ) {
            data.type = "text";
          }
          return data;
        });

        let updatedResult = res.body.results.map((data) => {

          const isNewRecordForTruckOverhaul = data.number && data.number > this.truckOverhaulOrderNumber;
          
          if (isNewRecordForTruckOverhaul) {
            let driverNames = data?.driverName
              ? data.driverName.split(",")
              : [];
            let driverPhones = data?.driverPhone
              ? this.sharedService.getDriverPhonesStringArray(data.driverPhone)
              : [];
            let drivers: string[] = driverNames.map(
              (name: string, i: number) => {
                const phone = driverPhones[i] || "";
                return `${name.trim()}${phone ? ", " + phone : ""}`;
              }
            );
            data.driverName = drivers.join("\n");
          } 

          data.paparWorkNeeded = data.paparWorkNeeded ? data.paparWorkNeeded: null;
          data.confirmReadyForPickupvalue = data.confirmReadyForPickupvalue ?  data.confirmReadyForPickupvalue : null;
          data.confirmReadyForDeliveryvalue = data.confirmReadyForDeliveryvalue ? data.confirmReadyForDeliveryvalue : null;
          data.customerExpectedPickupDates =
            data.customerExpectedPickupDates?.replaceAll("\\n", "\n");
          data.customerExpectedDeliveryDates =
            data.customerExpectedDeliveryDates?.replaceAll("\\n", "\n");
          data.carrierScheduledPickupDates =
            data.carrierScheduledPickupDates?.replaceAll("\\n", "\n");
          data.carrierScheduledDeliveryDates =
            data.carrierScheduledDeliveryDates?.replaceAll("\\n", "\n");
          data.pickupNewETADates = data.pickupNewETADates?.replaceAll(
            "\\n",
            "\n"
          );
          data.deliveryNewETADates = data.deliveryNewETADates?.replaceAll(
            "\\n",
            "\n"
          );
          data.carrierTransportResultsList =
            data.carrierTransportResultsList?.replaceAll("\\n", "\n");
          data.fscTransportResultsList =
            data.fscTransportResultsList?.replaceAll("\\n", "\n");
          let date = data.callback1date ? new Date(data.callback1date) : null;
          data.callback1time_only = date
            ? date?.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              })
            : null;
          let date1 = data.callback2date ? new Date(data.callback2date) : null;
          data.callback2time_only = date1
            ? date1?.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              })
            : null;
            data.callback1date_only = date
              ? `${date.getMonth() + 1}/${date.getDate()}/${
                  date.getFullYear() % 100
                }`
              : null;
            data.callback2date_only = date1
              ? `${date1.getMonth() + 1}/${date1.getDate()}/${
                  date1.getFullYear() % 100
                }`
              : null;
          return data;
        });
        this.loadColumns(updatedMetaData);
        this.model.rows = updatedResult;
        this.rowCount = res.body.count;

        this.navigationService.setTitleAndSub({
          title: this.title,
          subtitle: this.rowCount + " total",
        });
        this.isLoading = false;
      });
  }

  onSearchWeeklyReport() {
    this.isReportSearch = true;
    this.isLoading = true;
    if (!this.startDate) {
      this.setStartDateToMostRecentMonday();
    }
    const startDate = this.datePipe.transform(this.startDate, 'yyyy-MM-dd');
    const endDateObj = new Date(this.startDate.getTime());
    endDateObj.setDate(this.startDate.getDate() + 5);
    const endDate = this.datePipe.transform(endDateObj, 'yyyy-MM-dd');

    this.startDateReport = this.datePipe.transform(startDate, 'MM/dd/yyyy');
    this.endDateReport = this.datePipe.transform(endDate, 'MM/dd/yyyy');

    this.reportingService
      .getWeeklyReportData(startDate, endDate)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res: any) => {
          this.totalWeek = {
            totalMonday: 0,
            totalTuesday: 0,
            totalWednesday: 0,
            totalThursday: 0,
            totalFriday: 0,
            totalSaturday: 0,
            total: 0,
          };
          this.reportData = res?.body?.result;
          this.reportData.forEach((ele) => {
            this.totalWeek.totalMonday =
              this.totalWeek.totalMonday + ele.monday;
            this.totalWeek.totalTuesday =
              this.totalWeek.totalTuesday + ele.tuesday;
            this.totalWeek.totalWednesday =
              this.totalWeek.totalWednesday + ele.wednesday;
            this.totalWeek.totalThursday =
              this.totalWeek.totalThursday + ele.thursday;
            this.totalWeek.totalFriday =
              this.totalWeek.totalFriday + ele.friday;
            this.totalWeek.totalSaturday =
              this.totalWeek.totalSaturday + ele.saturday;
          });
          this.totalWeek.total =
            this.totalWeek.totalMonday +
            this.totalWeek.totalTuesday +
            this.totalWeek.totalWednesday +
            this.totalWeek.totalThursday +
            this.totalWeek.totalFriday +
            this.totalWeek.totalSaturday;
          this.isLoading = false;
        },
        (err) => {
          this.isLoading = false;
        }
      );
  }
  onGenerateReport() {
    this.isLoading = true;
    if (!this.startDate) {
      this.setStartDateToMostRecentMonday();
    }
    const startDate = this.datePipe.transform(this.startDate, 'yyyy-MM-dd');
    const endDateObj = new Date(this.startDate.getTime());
    endDateObj.setDate(this.startDate.getDate() + 5);
    const endDate = this.datePipe.transform(endDateObj, 'yyyy-MM-dd');
    this.reportingService
      .downloadWeeklyReportData(startDate, endDate)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.isLoading = false;
        },
        (err) => {
          this.isLoading = false;
        }
      );
  }

  clickChild(e: any, selected: boolean, hasReload: boolean) {
    let statusLabels = {
      'canceled': 'Canceled',
      'draft': 'Drafts',
      'created': 'New',
      'readyfordispatch': 'Ready To Dispatch',
      'dispatched': 'Dispatched',
      'pickedup': 'Picked Up',
      'delivered': 'Delivered',
      'complete': 'Move Complete',
      'weekly_reporting': 'Weekly Profit Report',
      'vip_rush_order_dispatched': 'VIP/RUSH Orders',
      'vip_rush_today_order_dispatched': 'VIP/RUSH Confirms Today',
      'asap_order_dispatched': 'ASAP Orders',
      'asap_today_order_dispatched': 'ASAP Confirms Today',
      'vip_rush_order_pickedup': 'VIP/RUSH Orders',
      'vip_rush_today_order_pickedup': 'VIP/RUSH Confirms Today',
      'asap_order_pickedup': 'ASAP Orders',
      'asap_todayorder_pickedup': 'ASAP Confirms Today',
      'driver_info_needed_dispatched': 'Driver Info Needed',
      'driver_info_needed_pickedup': 'Driver Info Needed',
    }

    let statuses = {
      'canceled': -1,
      'draft': 0,
      'created': 1,
      'readyfordispatch': 2,
      'dispatched': 3,
      'pickedup': 4,
      'delivered': 5,
      'complete': 6,
      'weekly_reporting': 7,
      'vip_rush_order_dispatched': 31,
      'vip_rush_today_order_dispatched': 331,
      'asap_order_dispatched': 32,
      'asap_today_order_dispatched': 321,
      'vip_rush_order_pickedup': 41,
      'vip_rush_today_order_pickedup': 441,
      'asap_order_pickedup': 42,
      'asap_todayorder_pickedup': 421,
      'driver_info_needed_dispatched': 33,
      'driver_info_needed_pickedup': 43,

    };

    if (selected) {
      delete this.params.status;
    } else {
      this.first = 0;
      if (statuses[e] != null) {
        this.params.status = statuses[e];
        this.title = 'Orders (' + statusLabels[e] + ')';
      }
      else{
        this.params.status = 8;
        this.title = 'Order In Process';
        // For Orders in Process, set isDataLoaded based on whether reps are selected
        this.isDataLoaded = this.proxy.length > 0;
      }
    }

    if (hasReload && statuses[e] != 7) {
      this.router.navigate([], { queryParams: this.params });
      this.load();
    } else if (hasReload && statuses[e] == 7) {
      this.setStartDateToMostRecentMonday();
      this.onSearchWeeklyReport();
      this.navigationService.setTitleAndSub({ title: this.title, subtitle: this.rowCount + ' total' });
    }
  }
 
  lazyLoad(e: any) {
    if (this.prevLazyLoadEvent && this.sharedService.isSameEvent(e, this.prevLazyLoadEvent)) {
      return;
    }
    setTimeout(() => {
      this.prevLazyLoadEvent = e;
      if (e.multiSortMeta !== undefined && e.multiSortMeta.length > 0) {
      e.multiSortMeta.map((sort) => {
        const sortIndex = this.multiSortMeta.findIndex((f: any) => { return f.field === sort.field; });
        if (sortIndex > -1) {
          if (this.multiSortMeta[sortIndex].order !== sort.order) {
            this.multiSortMeta[sortIndex].requireReload = true
          }
          this.multiSortMeta[sortIndex].order = sort.order;
        } else {
          this.multiSortMeta.push({ field: sort.field, order: sort.order, requireReload: true });
        }
      });
      // Check if any of colum require reload
      const requireReload = this.multiSortMeta.some((m: any) => {
        return m.requireReload;
      });
      // It will reload only when a new sort column is added or the previous one is altered
      if (requireReload) {
        this.multiSortMeta.forEach((m: any) => {
          return m.requireReload = false;
        });
        this.multiSortMeta = [...this.multiSortMeta];
        this.setGridState(e);
        this.load();
      }
    } else {
      this.setGridState(e);
      this.load();
    }
    }, 0);
  }


  rowChangePreview(id: string) {
    if (this.selectedRows.length > 1 && this.selectedRows.length <= 10) {
      this.navigationService.setBeginBulkEditButtonEnable(false);
    } else if (this.selectedRows.length > 10) {
      const index = this.selectedRows.findIndex((res) => res.id == id)
      this.selectedRows.splice(index, 1)
      this.messageService.add(this.toast(true, 'You cannot select more than 10 orders for bulk edit'));
    } else {
      this.navigationService.setBeginBulkEditButtonEnable(true);
    }
    if (this.navigationService.getNav().showRightNav) {
      this.navigationService.setRightNav('order', id);
    }
  }

  clickRowTools(event: RowToolEvent) {
    this.selection = event.item;
    switch (event.key) {
      case 'view':
        this.sharedService.setData("items", event.item);
        this.view(event.item?.guid);
        break;
      case 'edit':
        if (event.item?.isBulkUploadActive) {
          this.messageService.add(this.toast(true, 'Order cannot be edited as ' + event.item?.bulkUploadBy + ' is Bulk Dispatching'));
          return;
        }
        this.edit(event.item);
        break;
    }
  }

  edit(row: any) {
    this.selection = row;
    this.showModal = true;
  }

  view(id: string) {
    this.navigationService.setDetail('order', id);
  }

  add() {
    this.selection = null;
    this.showModal = true;
    this.showUserModal = false;
    this.isAdding = true;
  }

  addUser() {
    this.showModal = false;
    this.showUserModal = true;
    this.isAdding = true;
  }

  addLocation() {
    this.showLocationModal = true;
    this.showModal = false;
    this.showUserModal = false;
  }

  save(closeModal = true) {
    if (closeModal) {
      // this.showModal = false;
      this.cancel();
    }
    this.load();
  }

  revert(event){
    if (event) {
      this.load();
    }
  }

  cancel(orderId?: any) {
    // this.showModal = false;
    this.showUserModal = false;
    this.isEditing = false;
    this.isAdding = false;
    this.isDeleting = false;
    this.showLocationModal = false;
    if ((this.showBulkEditModal || this.showModal) && orderId?.length > 0) {
      this.accountService
        .setAllowOrdersEdit(orderId?.map((res) => res))
        .subscribe((r) => {});
    }
    this.showBulkEditModal = false;
    this.showModal = false;
  }

  rowColor(item: any): string {
    if (item.isCanceled) {
      return 'rgba(250, 0, 0, 0.1)';
    } else if (item.actionRequired) {
      return 'rgba(250, 250, 0, 0.1)'
    } else if (item.colourCode && !item.colourCodeStatusOIP) {
      return item.colourCode;
    }else if (item.oipColourCode && item.colourCodeStatusOIP) {
      return item.oipColourCode;
    }
    else {
      return null;
    }
  }

  openUnlockConfirm(item: any) {
    if (!this.hasUnlockPermission) {
      return;
    }
    this.unlockOrderItem = item;
    this.showUnlockConfirm = true;
  }

  onUnlockConfirm(confirmed: boolean) {
    this.showUnlockConfirm = false;
    if (!confirmed || !this.unlockOrderItem) {
      this.unlockOrderItem = null;
      return;
    }
    const orderId = this.unlockOrderItem.id;
    const orderNumber = this.unlockOrderItem.number;
    this.unlockOrderItem = null;
    this.accountService
      .setAllowOrdersEdit([orderId])
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.messageService.add(
            this.toast(true, `Order ${orderNumber} unlocked successfully.`),
          );
          this.load();
        },
        error: () => {
          this.messageService.add(
            this.toast(false, "Failed to unlock order. Please try again."),
          );
        },
      });
  }
  
  setStartDateToMostRecentMonday(): void {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const dayOfWeek = today.getDay();
    if (dayOfWeek === 1) {
      this.startDate = new Date(today);
    } else {
      const daysToGoBack = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
      const lastMonday = new Date(today);
      lastMonday.setDate(today.getDate() - daysToGoBack);
      this.startDate = lastMonday;
    }
  }
}
